import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const HomePage = lazy(() => import("../pages/home/page"));
const DownloadPage = lazy(() => import("../pages/thank-you/page"));
const NotFoundPage = lazy(() => import("../pages/NotFound"));

// Blog index
const BlogIndexPage = lazy(() => import("../pages/blog/index/page"));

// Strength Training — Batch 1
const StrengthTrainingBeginnersGuidePage = lazy(() => import("../pages/blog/strength-training-beginners-guide/page"));
const BestExercisesOver60Page = lazy(() => import("../pages/blog/best-exercises-over-60/page"));
const BuildMuscleAfter60Page = lazy(() => import("../pages/blog/build-muscle-after-60/page"));
const WeightTrainingSafetyPage = lazy(() => import("../pages/blog/weight-training-safety-tips/page"));
const ResistanceTrainingSeniorsPage = lazy(() => import("../pages/blog/resistance-training-seniors/page"));

// Motivation & Mindset — Batch 2
const TooOldToGetInShapePage = lazy(() => import("../pages/blog/too-old-to-get-in-shape/page"));
const FitnessTransformationOver60Page = lazy(() => import("../pages/blog/fitness-transformation-over-60/page"));
const WorkoutMotivationOlderMenPage = lazy(() => import("../pages/blog/workout-motivation-for-older-men/page"));
const GettingBackInShapeAt60Page = lazy(() => import("../pages/blog/getting-back-in-shape-at-60/page"));

// Health Conditions — Batch 2
const ExerciseAfterHeartAttackPage = lazy(() => import("../pages/blog/exercise-after-heart-attack-over-60/page"));
const ExerciseHighBloodPressurePage = lazy(() => import("../pages/blog/exercise-with-high-blood-pressure-over-60/page"));

// Health Conditions — Batch 3
const ExerciseDiabeticMenPage = lazy(() => import("../pages/blog/exercise-for-diabetic-men-over-60/page"));
const ExerciseWithArthritisPage = lazy(() => import("../pages/blog/exercise-with-arthritis-over-60/page"));
const ExercisesAfterKneeReplacementPage = lazy(() => import("../pages/blog/exercises-after-knee-replacement-over-60/page"));
const ExerciseForProstateHealthPage = lazy(() => import("../pages/blog/exercise-for-prostate-health-over-60/page"));

// Health & Recovery — Batch 3
const JointPainExercisesPage = lazy(() => import("../pages/blog/joint-pain-exercises-for-seniors/page"));
const KneeFriendlyExercisesPage = lazy(() => import("../pages/blog/knee-friendly-exercises-for-seniors/page"));
const ShoulderExercisesPage = lazy(() => import("../pages/blog/shoulder-exercises-for-men-over-60/page"));
const BackExercisesPage = lazy(() => import("../pages/blog/back-exercises-for-men-over-60/page"));
const BalanceExercisesPage = lazy(() => import("../pages/blog/balance-exercises-for-men-over-60/page"));

// Health & Recovery — Final Batch
const StretchingRoutinePage = lazy(() => import("../pages/blog/stretching-routine-for-men-over-60/page"));
const RecoveryTipsPage = lazy(() => import("../pages/blog/recovery-tips-for-older-athletes/page"));

// Nutrition — Final Batch
const ProteinIntakePage = lazy(() => import("../pages/blog/protein-intake-for-men-over-60/page"));
const BestProteinPowderPage = lazy(() => import("../pages/blog/best-protein-powder-for-men-over-60/page"));
const SupplementsPage = lazy(() => import("../pages/blog/supplements-for-men-over-60/page"));
const MealPlanPage = lazy(() => import("../pages/blog/meal-plan-for-men-over-60/page"));
const CreatinePage = lazy(() => import("../pages/blog/creatine-for-men-over-60/page"));

// Comparisons — Final Batch
const BestWorkoutProgramPage = lazy(() => import("../pages/blog/best-workout-program-for-men-over-60/page"));
const PersonalTrainerVsOnlinePage = lazy(() => import("../pages/blog/personal-trainer-vs-online-program-over-60/page"));
const GymVsHomePage = lazy(() => import("../pages/blog/gym-vs-home-workout-for-men-over-60/page"));
const CrossfitOver60Page = lazy(() => import("../pages/blog/crossfit-over-60/page"));
const YogaVsStrengthPage = lazy(() => import("../pages/blog/yoga-vs-strength-training-over-60/page"));

const routes: RouteObject[] = [
  { path: "/", element: <HomePage /> },
  { path: "/download", element: <DownloadPage /> },

  // Blog index
  { path: "/blog", element: <BlogIndexPage /> },

  // Strength Training
  { path: "/blog/strength-training-for-men-over-60-beginners-guide", element: <StrengthTrainingBeginnersGuidePage /> },
  { path: "/blog/best-exercises-for-men-over-60", element: <BestExercisesOver60Page /> },
  { path: "/blog/how-to-build-muscle-after-60", element: <BuildMuscleAfter60Page /> },
  { path: "/blog/weight-training-over-60-safety-tips", element: <WeightTrainingSafetyPage /> },
  { path: "/blog/resistance-training-for-seniors", element: <ResistanceTrainingSeniorsPage /> },

  // Motivation
  { path: "/blog/too-old-to-get-in-shape", element: <TooOldToGetInShapePage /> },
  { path: "/blog/fitness-transformation-over-60", element: <FitnessTransformationOver60Page /> },
  { path: "/blog/workout-motivation-for-older-men", element: <WorkoutMotivationOlderMenPage /> },
  { path: "/blog/getting-back-in-shape-at-60", element: <GettingBackInShapeAt60Page /> },

  // Health Conditions
  { path: "/blog/exercise-after-heart-attack-over-60", element: <ExerciseAfterHeartAttackPage /> },
  { path: "/blog/exercise-with-high-blood-pressure-over-60", element: <ExerciseHighBloodPressurePage /> },
  { path: "/blog/exercise-for-diabetic-men-over-60", element: <ExerciseDiabeticMenPage /> },
  { path: "/blog/exercise-with-arthritis-over-60", element: <ExerciseWithArthritisPage /> },
  { path: "/blog/exercises-after-knee-replacement-over-60", element: <ExercisesAfterKneeReplacementPage /> },
  { path: "/blog/exercise-for-prostate-health-over-60", element: <ExerciseForProstateHealthPage /> },

  // Health & Recovery
  { path: "/blog/joint-pain-exercises-for-seniors", element: <JointPainExercisesPage /> },
  { path: "/blog/knee-friendly-exercises-for-seniors", element: <KneeFriendlyExercisesPage /> },
  { path: "/blog/shoulder-exercises-for-men-over-60", element: <ShoulderExercisesPage /> },
  { path: "/blog/back-exercises-for-men-over-60", element: <BackExercisesPage /> },
  { path: "/blog/balance-exercises-for-men-over-60", element: <BalanceExercisesPage /> },
  { path: "/blog/stretching-routine-for-men-over-60", element: <StretchingRoutinePage /> },
  { path: "/blog/recovery-tips-for-older-athletes", element: <RecoveryTipsPage /> },

  // Nutrition
  { path: "/blog/protein-intake-for-men-over-60", element: <ProteinIntakePage /> },
  { path: "/blog/best-protein-powder-for-men-over-60", element: <BestProteinPowderPage /> },
  { path: "/blog/supplements-for-men-over-60", element: <SupplementsPage /> },
  { path: "/blog/meal-plan-for-men-over-60", element: <MealPlanPage /> },
  { path: "/blog/creatine-for-men-over-60", element: <CreatinePage /> },

  // Comparisons
  { path: "/blog/best-workout-program-for-men-over-60", element: <BestWorkoutProgramPage /> },
  { path: "/blog/personal-trainer-vs-online-program-over-60", element: <PersonalTrainerVsOnlinePage /> },
  { path: "/blog/gym-vs-home-workout-for-men-over-60", element: <GymVsHomePage /> },
  { path: "/blog/crossfit-over-60", element: <CrossfitOver60Page /> },
  { path: "/blog/yoga-vs-strength-training-over-60", element: <YogaVsStrengthPage /> },

  { path: "*", element: <NotFoundPage /> },
];

export default routes;
